import {Component, OnDestroy, OnInit} from '@angular/core';
import {ContactService} from '../../../../../common/services/contact.service';
import {ToastrService} from 'ngx-toastr';
import {GeneralService} from '../../../../../_services/general.service';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.css']
})
export class ContactPageComponent implements OnInit, OnDestroy {

  contact: any = {};
  submitted = false;
  loading = false;
  saveContact$: any;
  successMessage: string | undefined;

  subjects = [
    {name: 'Update token information', value: 'Update token information'},
    {name: 'Advertising inquiry', value: 'Advertising inquiry'},
    {name: 'Other', value: 'Other'}
  ];

  constructor(
    private contactService: ContactService,
    private toastr: ToastrService,
    private generalService: GeneralService,
    private titleService: Title
  ) {
    this.titleService.setTitle('Contact - CoinCatapult');
  }

  ngOnInit() {

  }

  save(form: any) {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.submitted = true;
    if (!form.valid) {
      this.loading = false;
      return;
    }
    this.submitted = false;

    this.saveContact$ = this.contactService.saveFrontObject(this.contact)
      .subscribe(
        (data: any) => {
          if (data.response) {
            this.submitted = false;
            this.loading = false;
            this.successMessage = 'We received your message and we will get back to you as soon as possible.';
            form.reset();
            this.contact = {};
          } else {
            this.loading = false;
            this.toastr.error(data.error_code.message);
          }

        },
        (error: any) => {
          this.loading = false;
          this.toastr.error(error);
        });
  }

  isEmpty(obj: {}) {
    return Object.keys(obj).length === 0;
  }


  ngOnDestroy(): void {
    if (this.saveContact$) {
      this.saveContact$.unsubscribe();
    }

  }

}
